/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SEARCH_INVOICE_AUDIT_TAB_DATA = 'SEARCH_INVOICE_AUDIT_TAB_DATA';
export const SEARCH_SCREEN_TAB_DATA = 'SEARCH_SCREEN_TAB_DATA';
export const INVOICE_AUDIT_DETAIL_TAB_DATA = 'INVOICE_AUDIT_DETAIL_TAB_DATA';

export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_ALL_AUDITS_POSSIBLE = 'GET_ALL_AUDITS_POSSIBLE';
export const GET_COMMON_DROPDOWN_DATA = 'GET_COMMON_DROPDOWN_DATA';
export const GET_QUARTER_DATA = 'GET_QUARTER_DATA';
export const GET_AUDIT_TYPE_CD = 'GET_AUDIT_TYPE_CD';
export const GET_MANUFACTURER_DATA = 'GET_MANUFACTURER_DATA';
export const GET_CHECK_DETAILS = 'GET_CHECK_DETAILS';
export const SELECTED_REBATE_PROGRAM = 'SELECTED_REBATE_PROGRAM';
export const QTR_VALUE = 'QTR_VALUE';
export const HANDLE_ERROR_MESSAGE_FOR_IA = 'HANDLE_ERROR_MESSAGE_FOR_IA';
export const GET_SEARCH_INVOICE_BY_CRITERIA = 'GET_SEARCH_INVOICE_BY_CRITERIA';
export const GET_NDC_LEVEL_DETAIL_LIST = 'GET_NDC_LEVEL_DETAIL_LIST';
export const GET_NDC_AUDIT_DESCRIPTION = 'GET_NDC_AUDIT_DESCRIPTION';
export const SAVE_OR_UPDATE = 'SAVE_OR_UPDATE';
export const PAGINATE_VALUE_FOR_DISPLAY = 'PAGINATE_VALUE_FOR_DISPLAY';
export const PERV_SEARCH_INVOICE_CRITERIA_DATA =
  'PERV_SEARCH_INVOICE_CRITERIA_DATA';
export const ALL_CHANGES_INVOICE_AUDITS_DATA_LIST =
  'ALL_CHANGES_INVOICE_AUDITS_DATA_LIST';
export const SELECTED_INVOICE_AUDIT_TYPE = 'SELECTED_INVOICE_AUDIT_TYPE';
